<template>
    <div>
        <vs-dialog v-model="customizationDialog">
            <h3>{{ $t('cookieConsent.customize.title') }}</h3>

            <vs-checkbox v-model="settings.tecnical" disabled>
                {{ $t('cookieConsent.customize.technical') }}
            </vs-checkbox>

            <vs-checkbox v-model="settings.analytics_storage">
                {{ $t('cookieConsent.customize.analytics') }}
            </vs-checkbox>

            <vs-checkbox v-model="settings.functionality_storage">
                {{ $t('cookieConsent.customize.functional') }}
            </vs-checkbox>

            <vs-checkbox v-model="settings.personalization_storage">
                {{ $t('cookieConsent.customize.personalization') }}
            </vs-checkbox>



            <vs-checkbox v-model="settings.tourial_storage">
                {{ $t('cookieConsent.customize.campaignTracking') }}
            </vs-checkbox>

            <!--
            <vs-checkbox v-model="settings.ad_storage">
                Cookie per la pubblicità
            </vs-checkbox>

            <vs-checkbox v-model="settings.ad_user_data">
                Dati utente per la pubblicità
            </vs-checkbox>

            <vs-checkbox v-model="settings.ad_personalization">
                Personalizzazione della pubblicità
            </vs-checkbox>

            <vs-checkbox v-model="settings.security_storage">
                Cookie di sicurezza
            </vs-checkbox>
            -->

            <vs-button block @click="applyChanges" size="large" style="margin:0!important; margin-top: 20px;">
                {{ $t('cookieConsent.customize.apply') }}
            </vs-button>
        </vs-dialog>
        <div class="wised-cookie-consent animate__animated animate__slideInUp " v-if="visible">
            <div class="wised-cookie-consent__content">
                <div class="wised-cookie-consent__text">
                    <p>
                        {{ $t('cookieConsent.banner.textBeforeLink') }} <router-link to="/cookie-policy">{{ $t('homepage.footer.links.cookiePolicy') }}</router-link>{{ $t('cookieConsent.banner.textAfterLink') }}
                    </p>
                </div>
                <div class="wised-cookie-consent__buttons">
                    <vs-button border size="large" @click="customize">
                        {{ $t('cookieConsent.banner.customize') }}
                    </vs-button>
                    <vs-button size="large" @click="acceptAll">
                        {{ $t('cookieConsent.banner.acceptAll') }}
                    </vs-button>
                </div>
            </div>
        </div>
        <div v-else class="wised-cookie-consent__settings animate__animated animate__slideInLeft" :class="{'no-menu': $route.meta.hiddenMenu}" @click="visible = true">
            {{ $t('cookieConsent.manage') }}
        </div>
</div>
</template>

<script>
import 'animate.css';
export default {
    name: "WisedCookieConsent",

    data() {
        return {
            visible: false,

            settings: {
                tecnical: true,

                // GOOGLE ANALYTICS 4
                ad_storage: false,
                ad_user_data: false,
                ad_personalization: false,
                analytics_storage: true,
                functionality_storage: true,
                personalization_storage: true,
                security_storage: false,

                // TOURIAL
                tourial_storage: true, // campaign tracking
            },

            customizationDialog: false
        }
    },

    methods: {
        acceptAll() {
            this.settings.tourial_storage = true;
            this.settings.analytics_storage = true;
            this.settings.functionality_storage = true;
            this.settings.personalization_storage = true;
            
            this.applyChanges();
        },

        customize(){
            this.customizationDialog = true;
        },

        applyChanges(){
            // store settings as CSV in cookie
            let settings = '';
            for (let key in this.settings) {
                if (this.settings[key]) {
                    settings += key + ',';
                }
            }

            if(this.$IS_APP){
                localStorage.setItem('TOURIAL-X', settings);
            } else {
                this.$cookie.set('TOURIAL-X', settings, 180);
            }
            this.customizationDialog = false;
            this.visible = false;

            this.handleAnalytics();
        },

        handleAnalytics(){
            if(this.settings.tourial_storage && this.$route.query.i) { // accepted cookies before and opened a campaign url now
                // website opened from a campaign and has the query param i = campaign id
                this.$cookie.set('TOURIAL-C', this.$route.query.i, 180);
            }

            window.gtag('consent', 'update', {
                ad_storage: this.settings.ad_storage ? 'granted' : 'denied',
                ad_user_data:  this.settings.ad_user_data ? 'granted' : 'denied',
                ad_personalization:  this.settings.ad_personalization ? 'granted' : 'denied',
                analytics_storage:  this.settings.analytics_storage ? 'granted' : 'denied',
                functionality_storage:  this.settings.functionality_storage ? 'granted' : 'denied',
                personalization_storage:  this.settings.personalization_storage ? 'granted' : 'denied',
                security_storage:  this.settings.security_storage ? 'granted' : 'denied',
            });
        }
    },

    mounted() {

        if(this.$route.meta.print) return; // don't show on print pages
        setTimeout(() => {
            let settingsData = null;
            if(this.$IS_APP){
                settingsData = localStorage.getItem('TOURIAL-X');
            } else {
                settingsData = this.$cookie.get('TOURIAL-X');
            }


            if (settingsData == null) { // never accepted or declined
                this.visible = true;
            } else {
                // deserialize settings
                let settings = settingsData.split(',');
                for (let key in this.settings) {
                    if (settings.includes(key)) {
                        this.settings[key] = true;
                    } else {
                        this.settings[key] = false;
                    }
                }

                this.handleAnalytics();

            }
        }, 2000)

    }
}
</script>

<style>
.wised-cookie-consent__settings {
    position: fixed;
    bottom: 0;
    left: 0;
    background-color: #fff;
    padding: 0.5rem;
    color: var(--primary);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    z-index: 9999;
    text-align: left;
    cursor: pointer;
    border-top-right-radius: 10px;
    font-size: 0.8rem;
}

.wised-cookie-consent {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    padding: 1rem;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    z-index: 9999;
}

.wised-cookie-consent__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.wised-cookie-consent__text {
    font-size: 0.9rem;
}

.wised-cookie-consent__buttons {
    display: flex;
    justify-content: flex-end;
    gap: 1rem;
}

.wised-cookie-consent__buttons button {
    white-space: nowrap;
}

/* MOBILE */
@media (max-width: 600px) {
    .wised-cookie-consent__text {
        padding: 0;
        width: 100%;
    }

    .wised-cookie-consent__settings {
        bottom: calc(86px + env(safe-area-inset-bottom));
        left: 25px;
        box-shadow: none;
        background: rgba(255,255,255, 0.65);
        -webkit-backdrop-filter: saturate(150%) blur(10px);
        backdrop-filter: saturate(150%) blur(10px);
        border: 1px solid rgba(255,255,255,0.35);
        border-radius: 12px;
        font-size: 0.7rem;
        padding: 0.25rem 0.6rem;
        padding-right: 0.6rem;
    }

    .wised-cookie-consent__settings.no-menu {
        bottom: calc(12px + env(safe-area-inset-bottom)) !important;
        left: 12px !important;
    }

    .wised-cookie-consent__content {
        flex-direction: column;
        padding: 0.5rem
    }

    .wised-cookie-consent__buttons {
        flex-direction: column;
        width: 100%;
    }
    .wised-cookie-consent__buttons button {
        width: 100%;
        margin: 0;
    }
}
</style>
